export default "__VITE_ASSET__hQ45m3sS__"